import type { StylesConfig } from 'react-select';
import { selectStylesDark, selectStylesLigth } from 'utils/helpers/structs/selectStyles';
import type { FilterOption } from '../model/types';

/** Вище за Bootstrap offcanvas (~1045), щоб меню селекту було видно */
const MENU_Z_INDEX = 2100;

/** Як фільтр категорій у товарах: сині чіпи з selectStyles, без стилів типу/статусу. */
export const buildCategorySelectStyles = (dark: boolean): StylesConfig<FilterOption, true> => {
    const base = (dark ? selectStylesDark : selectStylesLigth) as StylesConfig<FilterOption, true>;

    return {
        ...base,
        menu: (styles, state) => ({
            ...(base.menu ? base.menu(styles, state) : styles),
            zIndex: MENU_Z_INDEX,
        }),
        menuPortal: (styles) => ({
            ...styles,
            zIndex: MENU_Z_INDEX,
        }),
    };
};

export const buildSelectStyles = (dark: boolean): StylesConfig<FilterOption, true> => {
    const base = (dark ? selectStylesDark : selectStylesLigth) as StylesConfig<FilterOption, true>;

    return {
        ...base,
        control: (styles, state) => ({
            ...(base.control ? base.control(styles, state) : styles),
            minHeight: 38,
            fontSize: '0.8125rem',
            paddingBlock: 2,
        }),
        valueContainer: (styles, state) => ({
            ...(base.valueContainer ? base.valueContainer(styles, state) : styles),
            gap: 4,
            paddingTop: 2,
            paddingBottom: 2,
        }),
        indicatorsContainer: (styles) => ({
            ...styles,
            alignSelf: 'stretch',
        }),
        multiValue: () => ({
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'transparent',
            borderRadius: 0,
            margin: 0,
            padding: 0,
            maxWidth: '100%',
        }),
        multiValueLabel: () => ({
            padding: 0,
            fontSize: 'inherit',
            color: 'inherit',
            whiteSpace: 'nowrap',
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            borderRadius: 6,
            padding: '0 4px',
            marginLeft: 2,
            color: dark ? '#9ca3af' : '#6b7280',
            ':hover': {
                backgroundColor: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
                color: dark ? '#fff' : '#111827',
            },
        }),
        menu: (styles, state) => ({
            ...(base.menu ? base.menu(styles, state) : styles),
            zIndex: MENU_Z_INDEX,
            fontSize: '0.8125rem',
            overflow: 'hidden',
        }),
        menuList: (styles, state) => ({
            ...(base.menuList ? base.menuList(styles, state) : styles),
            maxHeight: 240,
            paddingTop: 4,
            paddingBottom: 4,
        }),
        menuPortal: (styles) => ({
            ...styles,
            zIndex: MENU_Z_INDEX,
        }),
        option: (styles, state) => ({
            ...(base.option ? base.option(styles, state) : styles),
            fontSize: '0.8125rem',
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 10,
            paddingRight: 10,
            cursor: 'pointer',
            backgroundColor: state.isFocused
                ? dark
                    ? 'rgba(255,255,255,0.06)'
                    : '#F3F4F6'
                : state.isSelected
                  ? dark
                      ? 'rgba(70,128,255,0.18)'
                      : '#EEF4FF'
                  : 'transparent',
        }),
        placeholder: (styles) => ({
            ...styles,
            fontSize: '0.8125rem',
            color: dark ? '#8b95a1' : '#9ca3af',
        }),
    };
};
